'use strict';

import execute_on from "../../../../libs/execute-on";
import "dropzone";
import {getCsrfToken} from "../../../../plugins/get-csrf-token";
import {swalFire} from "../../../../plugins/sweet-alert/sweet-alert-default";

execute_on('admin.cms.help.edit', function() {
    const $dropzoneElement = $(".helpMessagesDropzone");
    $dropzoneElement.dropzone({
        url: $dropzoneElement.data('route'),
        addRemoveLinks: true,
        headers: {
            'X-CSRF-TOKEN': getCsrfToken()
        },
        maxFiles: 1,
        init: (function() {
            const dzClosure = this;
            $(".dz-submit").on('click', function(event) {
                event.preventDefault();
                dzClosure.processQueue();
            });
            dzClosure.on("success", function(file, response) {
                swalFire({
                    'title': 'Help messages import report',
                    'html': 'All messages: ' + response.all + "<br/>" +
                        'Changed messages: ' + response.changes + "<br/>" +
                        'Errors: ' + response.errors + "<br/>" +
                        'Errors for keys: ' + response.errorKeys.join(", "),
                });
            });
        }),
        clickable: true,
        autoProcessQueue: false,
        acceptedFiles: '.xlsx'
    });
});
